<mat-dialog-content>
  <div class="reconnect-dialog-content">
    <mat-icon class="reconnect-dialog-icon" fontSet="material-icons">error_outline</mat-icon>
    <h6 class="reconnect-dialog-title">Σφάλμα Σύνδεσης</h6>
    <p class="reconnect-dialog-subtitle">Η συνεδρία σας δεν είναι έγκυρη</p>
    <button mat-raised-button class="reconnect-dialog-btn" (click)="reconnect()">
      Επανασύνδεση
    </button>
  </div>
</mat-dialog-content>
